export const CityType = {
    Adana: 1,
    Adiyaman: 2,
    Afyonkarahisar: 3,
    Agri: 4,
    Amasya: 5,
    Ankara: 6,
    Antalya: 7,
    Artvin: 8,
    Aydin: 9,
    Balikesir: 10,
    Bilecik: 11,
    Bingol: 12,
    Bitlis: 13,
    Bolu: 14,
    Burdur: 15,
    Bursa: 16,
    Canakkale: 17,
    Cankiri: 18,
    Corum: 19,
    Denizli: 20,
    Diyarbakir: 21,
    Edirne: 22,
    Elazig: 23,
    Erzincan: 24,
    Erzurum: 25,
    Eskisehir: 26,
    Gaziantep: 27,
    Giresun: 28,
    Gumushane: 29,
    Hakkari: 30,
    Hatay: 31,
    Isparta: 32,
    Mersin: 33,
    Istanbul: 34,
    Izmir: 35,
    Kars: 36,
    Kastamonu: 37,
    Kayseri: 38,
    Kirklareli: 39,
    Kirsehir: 40,
    Kocaeli: 41,
    Konya: 42,
    Kutahya: 43,
    Malatya: 44,
    Manisa: 45,
    Kahramanmaras: 46,
    Mardin: 47,
    Mugla: 48,
    Mus: 49,
    Nevsehir: 50,
    Nigde: 51,
    Ordu: 52,
    Rize: 53,
    Sakarya: 54,
    Samsun: 55,
    Siirt: 56,
    Sinop: 57,
    Sivas: 58,
    Tekirdag: 59,
    Tokat: 60,
    Trabzon: 61,
    Tunceli: 62,
    Sanliurfa: 63,
    Usak: 64,
    Van: 65,
    Yozgat: 66,
    Zonguldak: 67,
    Aksaray: 68,
    Bayburt: 69,
    Karaman: 70,
    Kirikkale: 71,
    Batman: 72,
    Sirnak: 73,
    Bartin: 74,
    Ardahan: 75,
    Igdir: 76,
    Yalova: 77,
    Karabuk: 78,
    Kilis: 79,
    Osmaniye: 80,
    Duzce: 81,
};

export const cityOptions = [
    { value: 1, label: "Adana" },
    { value: 2, label: "Adıyaman" },
    { value: 3, label: "Afyonkarahisar" },
    { value: 4, label: "Ağrı" },
    { value: 5, label: "Amasya" },
    { value: 6, label: "Ankara" },
    { value: 7, label: "Antalya" },
    { value: 8, label: "Artvin" },
    { value: 9, label: "Aydın" },
    { value: 10, label: "Balıkesir" },
    { value: 11, label: "Bilecik" },
    { value: 12, label: "Bingöl" },
    { value: 13, label: "Bitlis" },
    { value: 14, label: "Bolu" },
    { value: 15, label: "Burdur" },
    { value: 16, label: "Bursa" },
    { value: 17, label: "Çanakkale" },
    { value: 18, label: "Çankırı" },
    { value: 19, label: "Çorum" },
    { value: 20, label: "Denizli" },
    { value: 21, label: "Diyarbakır" },
    { value: 22, label: "Edirne" },
    { value: 23, label: "Elazığ" },
    { value: 24, label: "Erzincan" },
    { value: 25, label: "Erzurum" },
    { value: 26, label: "Eskişehir" },
    { value: 27, label: "Gaziantep" },
    { value: 28, label: "Giresun" },
    { value: 29, label: "Gümüşhane" },
    { value: 30, label: "Hakkari" },
    { value: 31, label: "Hatay" },
    { value: 32, label: "Isparta" },
    { value: 33, label: "Mersin" },
    { value: 34, label: "İstanbul" },
    { value: 35, label: "İzmir" },
    { value: 36, label: "Kars" },
    { value: 37, label: "Kastamonu" },
    { value: 38, label: "Kayseri" },
    { value: 39, label: "Kırklareli" },
    { value: 40, label: "Kırşehir" },
    { value: 41, label: "Kocaeli" },
    { value: 42, label: "Konya" },
    { value: 43, label: "Kütahya" },
    { value: 44, label: "Malatya" },
    { value: 45, label: "Manisa" },
    { value: 46, label: "Kahramanmaraş" },
    { value: 47, label: "Mardin" },
    { value: 48, label: "Muğla" },
    { value: 49, label: "Muş" },
    { value: 50, label: "Nevşehir" },
    { value: 51, label: "Niğde" },
    { value: 52, label: "Ordu" },
    { value: 53, label: "Rize" },
    { value: 54, label: "Sakarya" },
    { value: 55, label: "Samsun" },
    { value: 56, label: "Siirt" },
    { value: 57, label: "Sinop" },
    { value: 58, label: "Sivas" },
    { value: 59, label: "Tekirdağ" },
    { value: 60, label: "Tokat" },
    { value: 61, label: "Trabzon" },
    { value: 62, label: "Tunceli" },
    { value: 63, label: "Şanlıurfa" },
    { value: 64, label: "Uşak" },
    { value: 65, label: "Van" },
    { value: 66, label: "Yozgat" },
    { value: 67, label: "Zonguldak" },
    { value: 68, label: "Aksaray" },
    { value: 69, label: "Bayburt" },
    { value: 70, label: "Karaman" },
    { value: 71, label: "Kırıkkale" },
    { value: 72, label: "Batman" },
    { value: 73, label: "Şırnak" },
    { value: 74, label: "Bartın" },
    { value: 75, label: "Ardahan" },
    { value: 76, label: "Iğdır" },
    { value: 77, label: "Yalova" },
    { value: 78, label: "Karabük" },
    { value: 79, label: "Kilis" },
    { value: 80, label: "Osmaniye" },
    { value: 81, label: "Düzce" },
];

export const getCityLabel = (value) => {
    const found = cityOptions.find((o) => Number(o.value) === Number(value));
    return found ? found.label : "-";
};


